import styled from "styled-components";

export const MenuButton = styled.button`
  display: inline-flex;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.35;
  align-items: center;
  background-color: var(--ons-color-ocean-blue);
  color: var(--ons-color-white);
  border: 2px solid var(--ons-color-ocean-blue);
  border-radius: 3px;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    border: 2px solid var(--ons-color-white);
  }

  &:focus {
    border: 3px solid var(--ons-color-black);
    color: var(--ons-color-black);
    fill: var(--ons-color-black);
    background-color: var(--ons-color-sun-yellow);
  }

  &:focus-visible {
    outline: none;
  }
`;

export const MenuDisabledButton = styled.button<{
  $isNavigation?: boolean;
}>`
  display: inline-flex;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.35;
  align-items: center;
  background-color: var(--ons-color-ocean-blue);
  color: var(--ons-color-white);
  border: 2px solid var(--ons-color-ocean-blue);
  border-radius: 3px;
  padding: 10px;
  font-size: 16px;
  opacity: 50%;
  ${(props) => props.$isNavigation && "font-weight: 400 !important;"}
`;

export const ActionButton = styled.button<{
  $isOpen?: boolean;
  $isNavigation?: boolean;
  $isInverted?: boolean;
}>`
  display: inline-flex;
  box-sizing: border-box;
  line-height: 1.35;
  align-items: center;
  min-width: 105px;
  background-color: ${(props) =>
    props.$isNavigation || props.$isInverted
      ? props.$isOpen
        ? "var(--ons-color-ocean-blue)"
        : "transparent"
      : props.$isOpen
        ? "var(--ons-color-ocean-blue)"
        : "var(--ons-color-white)"};
  border: ${(props) =>
    props.$isNavigation
      ? props.$isOpen
        ? "2px solid var(--ons-color-night-blue)"
        : "2px solid transparent"
      : props.$isInverted
        ? "2px solid var(--ons-color-white)"
        : props.$isOpen
          ? "2px solid var(--ons-color-night-blue)"
          : "2px solid var(--ons-color-grey-75)"};
  border-radius: 3px;
  outline: none;
  padding: 10px;
  font-size: 16px;
  color: ${(props) =>
    props.$isNavigation
      ? props.$isOpen
        ? "var(--ons-color-white)"
        : "var(--ons-color-text-link)"
      : props.$isInverted
        ? "var(--ons-color-white)"
        : props.$isOpen
          ? "var(--ons-color-white)"
          : "var(--ons-color-grey-75)"};
  cursor: pointer;
  ${(props) => props.$isOpen && "margin-bottom: 4px;"}
  ${(props) => props.$isNavigation && "font-weight: 400 !important;"}

  &:hover {
    border: 2px solid var(--ons-color-text-link);
  }

  &:focus {
    border: 2px solid var(--ons-color-black);
    color: var(--ons-color-black);
    background-color: var(--ons-color-sun-yellow);
    & + ${MenuButton}:focus {
      border: 2px solid var(--ons-color-night-blue);
      background-color: var(--ons-color-ocean-blue);
      color: var(--ons-color-white);
    }
  }
`;
